import React, { useState } from 'react';
import { View } from 'react-native';
import {
  dictionary_installed_list, dictionary_installed_list_keys,
  dictionary_installed_str,
  opened_activation_str,
  ota,
  state_at_launch_str,
  with_keyboard,
} from '../../../utils/DictionaryManagementUtils';
import Title from '../Text/Title';
import Paragraph from '../Text/Paragraph';
import BreakLine from '../General/BreakLine';
import OpenBoxPanel from './OpenBoxPanel';
import { LocStr } from '../../../utils/Utils';

//= ========================================================================

const StateAtLaunchPanelComponent = ({
  children,
  language,
  onConfigChanged,
  keyboard_language,
}) => {
  const [isDictionaryInstalled, setDictionaryInstalled] = useState(false);

  return (
    <View style={{ backgroundColor: '#F7FAFC', padding: 14, marginTop: 30 }}>
      <Title>{state_at_launch_str}</Title>
      <Paragraph marginBottom={30}>{opened_activation_str}</Paragraph>
      {children}
      <BreakLine marginTop={10} />
      <View style={{ zIndex: 2 }}>
        <OpenBoxPanel
          cleanBackground
          language={language}
          isBoxOpen={isDictionaryInstalled}
          text={LocStr(dictionary_installed_str, language)}
          chosenValue={keyboard_language.is_OTA_dictionary_installed ? ota : with_keyboard}
          valuesMap={dictionary_installed_list}
          keysMap={dictionary_installed_list_keys}
          onPress={() => {
            setDictionaryInstalled(!isDictionaryInstalled);
          }}
          onValueChanged={(valueId) => {
            keyboard_language.is_OTA_dictionary_installed = valueId === ota;
            onConfigChanged();
          }}
          marginBottom={40}
          withSplit
          openBoxWidth={202}
          rightOffset={-10}
        />
      </View>

    </View>
  );
};
export default StateAtLaunchPanelComponent;
